import { LucideProps } from "lucide-react";
import { CoreEntityType } from "./enum"
import { BaseDataSchema } from "./global"

export type CodexEntryGroup = {
  label: string;
  id?: string;
  type?: CodexEntryType;
  icon?: (props: Omit<LucideProps, 'ref'>) => React.ReactElement;
  category?: CodexCategorySchema;
  children: CodexEntrySchema[];
}

/**
 * 代码库条目类型
 */
export enum CodexEntryType {
  Character = 'character',
  Location = 'location',
  Lore = 'lore',
  Object = 'object',
  Subplot = 'subplot',
  Other = 'other',
}

export interface CodexEntryField {
  id: string
  fieldId: string
  content: {
    textarea?: string,
    lineText?: string,
    select?: string[],
    codex?: string[],
  }
}

export enum CodexFieldType {
  Text = 'text',
  Line = 'line',
  Dropdown = 'dropdown',
  Codex = 'codex',
}

/**
 * 代码库条目结构体
 */
export interface CodexEntrySchema extends BaseDataSchema<CoreEntityType.CodexEntries> {
  attributes: {
    type: CodexEntryType,
    color?: string,
    name?: string,
    // 别称
    aliases?: string,
    // 标签
    tags?: string[],
    // 描述
    description?: string,
    // 备注
    notes?: string,
    // 总是包含
    alwaysInclude?: boolean,
    // 不跟踪
    doNotTrack?: boolean,
    // 不自动包含
    noAutoInclude?: boolean,
    // 不显示在AI中
    hideFromAi?: boolean,
    // 匹配排除
    matchExclusions?: string[],
    // 匹配大小写敏感
    matchCaseSensitive?: boolean,
    // 提示包含
    promptInclusions?: string[],
  }
  fields?: CodexEntryField[],
  links?: {
    thumbnail: boolean,
    externalReferences: string[],
  }
}

/**
 * 代码库字段结构体
 */
export interface CodexFieldSchema extends BaseDataSchema<CoreEntityType.CodexFields> {
  attributes: {
    name: string,
    type: CodexFieldType,
    collects: CodexEntryType[],
    aiContext: 'include' | 'exclude' | 'nsfw',
    settings: {
      select?: {
        options: {
          id: string,
          label: string,
          color: string,
        }[],
      },
      showInList: boolean,
    }
  }
}

/**
 * 代码库分类结构体
 */
export interface CodexCategorySchema extends BaseDataSchema<CoreEntityType.CodexCategories> {
  attributes: {
    color?: string,
    name: string,
    tags: string[],
    collects: CodexEntryType[],
    /**
     * 收集字段
     * @description codexField id和字段值
     */
    collectsFields: {
      id?: string
      value?: string
    }[]
  }
}

